// utils/camelToSnake.ts

/**
 * Convert a camelCase string to snake_case.
 */
export function camelToSnake(str: string): string {
  return str.replaceAll(/([A-Z])/g, "_$1").toLowerCase();
}

/**
 * Recursively converts all object keys from camelCase to snake_case.
 * Handles arrays, primitives, and nested objects.
 */
export function camelToSnakeObject(obj: any): any {
  if (Array.isArray(obj)) {
    return obj.map(camelToSnakeObject);
  } else if (obj && typeof obj === 'object' && obj.constructor === Object) {
    const newObj: Record<string, any> = {};
    Object.keys(obj).forEach((key) => {
      const newKey = camelToSnake(key);
      newObj[newKey] = camelToSnakeObject(obj[key]);
    });
    return newObj;
  }
  return obj;
}